


import { Action } from '@ngrx/store';
import { YourPension } from '../../model/ngrx/your-pension.model';
import * as YourPensionActions from './../actions/your-pension.actions';

export type Actions = YourPensionActions.Actions;

export function YourPensionReducer(state: YourPension[] = [], action: YourPensionActions.Actions) {
    switch (action.type) {
        case YourPensionActions.ADD_YOUR_PENSION:
            return [...state, action.payload];

        // Add this case:
        case YourPensionActions.REMOVE_YOUR_PENSION:
            state = [];
            return state;

        default:
            return state;
    }
}
